<template>
  <section class="about-page container my-5 py-5">
    <h3 class="section-heading">ABOUT US</h3>

    <p class="body-text">
      Welcome to Sehrish Mart, a trusted destination for authentic Skincare,
      Hair Care &amp; Body Care products from Korea, Japan, the UK, and beyond
      delivered across Bangladesh.
    </p>

    <p class="body-text">
      Since 2023, we have been curating a thoughtful selection of beauty and
      personal care products for our customers. From globally loved best-sellers
      to underrated gems, we seek out products that are genuinely worth
      discovering.
    </p>

    <p class="body-text">
      Our commitment is simple: authenticity, accessibility, and quality without
      compromising on affordability.
    </p>

    <h3 class="section-heading mt-5">OUR MISSION</h3>

    <p class="body-text">
      At Sehrish Mart, our mission is to make self-care more intentional,
      accessible, and rewarding.
    </p>

    <p class="body-text">
      We take the time to listen to your concerns, understand your individual
      needs, and help you navigate the overwhelming world of skincare and
      personal care through carefully considered product recommendations from
      our expert team.
    </p>

    <p class="body-text">
      Because we believe beauty is not merely about appearance. It is about
      self-confidence, self-expression, and taking the time to care for
      yourself.
    </p>

    <h3 class="section-heading mt-5">OUR VISION</h3>

    <p class="body-text">
      We envision Sehrish Mart as more than an online beauty store we aspire to
      build a trusted community where authenticity meets thoughtful care.
    </p>

    <p class="body-text">
      We are committed to continuously discovering exceptional products,
      introducing hidden gems to our customers, and creating a shopping
      experience built on transparency, reliability, and genuine customer
      satisfaction.
    </p>

    <p class="body-text">
      What began as a small venture in 2023 continues to grow with your trust.
    </p>

    <p class="body-text">
      Here&rsquo;s to better choices, meaningful self-care, and celebrating the
      skin you&rsquo;re in.
    </p>

    <h3 class="section-heading mt-5">MEET THE SEHRISH MART TEAM</h3>

    <p class="body-text">
      Behind Sehrish Mart is a team of people who bring different skills,
      perspectives, and experiences to the table. What brings us together is a
      shared belief in authenticity, thoughtful service, and doing things with
      purpose.
    </p>

    <div class="team-member">
      <h4 class="member-name">Founder &amp; CEO &mdash; Sumaiya Tabassum</h4>
      <p class="body-text">
        With a background in Chemistry, Sumaiya founded Sehrish Mart with a
        simple yet ambitious vision to make authentic beauty and personal care
        products more accessible without making them unnecessarily expensive.
      </p>
      <p class="body-text">
        Her focus has always been on building a brand that people can trust,
        rely on, and grow with.
      </p>
    </div>

    <div class="team-member">
      <h4 class="member-name">
        Co-Founder &amp; Operations Lead &mdash; Amirul Islam Sakib
      </h4>
      <p class="body-text">
        With an Engineering background, Amirul looks after the operational side
        of the business. From keeping things organised to ensuring smooth
        execution behind the scenes, he plays an essential role in turning ideas
        into action.
      </p>
    </div>

    <div class="team-member">
      <h4 class="member-name">Content Team Leader &mdash; Nabiha Shahid</h4>
      <p class="body-text">
        With a BBA background, Nabiha leads our content team and helps shape how
        Sehrish Mart communicates with its audience. Her role goes beyond
        creating content she helps make sure our voice remains genuine,
        relatable, and consistent.
      </p>
    </div>

    <h3 class="section-heading mt-5">ONE TEAM. ONE VISION.</h3>

    <p class="body-text">
      We may come from different backgrounds, but we&rsquo;re working towards the
      same goal to build a beauty and personal care brand where authenticity
      comes first, customers feel heard, and every experience matters.
    </p>

    <p class="body-text">This is the team behind Sehrish Mart.</p>

    <h3 class="section-heading mt-5">WHY CHOOSE US?</h3>

    <div class="reason">
      <h4 class="member-name">1. Authenticity, Always</h4>
      <p class="body-text">
        We never compromise when it comes to authenticity. Every product is
        carefully sourced so you can shop with complete confidence.
      </p>
    </div>

    <div class="reason">
      <h4 class="member-name">2. Carefully Curated</h4>
      <p class="body-text">
        We don&rsquo;t simply stock what&rsquo;s trending. Alongside popular
        best-sellers, we seek out underrated gems that we believe genuinely
        deserve your attention.
      </p>
    </div>

    <div class="reason">
      <h4 class="member-name">3. Guidance You Can Trust</h4>
      <p class="body-text">
        Your skin and hair are unique. Our team takes the time to understand
        your concerns and offer thoughtful, personalised recommendations rather
        than one-size-fits-all suggestions.
      </p>
    </div>

    <div class="reason">
      <h4 class="member-name">4. Quality Within Reach</h4>
      <p class="body-text">
        Good self-care shouldn&rsquo;t feel out of reach. We strive to bring you
        authentic, quality products at fair and accessible prices.
      </p>
    </div>

    <div class="reason">
      <h4 class="member-name">5. Your Satisfaction Matters</h4>
      <p class="body-text">
        For us, a purchase is more than a transaction. We value the trust you
        place in us and continuously work to make your experience with Sehrish
        Mart better.
      </p>
    </div>

    <p class="body-text">
      Because choosing the right product is important but choosing where you buy
      it from matters too.
    </p>
  </section>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style lang="scss" scoped>
.about-page {
  max-width: 1200px;

  .section-heading {
    font-size: 1.1rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #6b6b6b;
    margin-bottom: 1.75rem;
  }

  .body-text {
    font-size: 1.15rem;
    line-height: 1.6;
    color: #6b6b6b;
    margin-bottom: 2.5rem;
  }

  .team-member,
  .reason {
    margin-bottom: 2.5rem;

    .body-text {
      margin-bottom: 1rem;
    }
  }

  .member-name {
    font-size: 1.15rem;
    font-weight: 700;
    color: #6b6b6b;
    margin-bottom: 0.75rem;
  }
}
</style>
